const MEMBER_INVOICES_STORAGE_KEY = 'member_invoices_data'

export {
    MEMBER_INVOICES_STORAGE_KEY
}